module.exports = __webpack_public_path__ + "img/vpspackage.1afa52e.png";